import { render, staticRenderFns } from "./ClicNotificationInterno.vue?vue&type=template&id=2bfd119a&"
import script from "./ClicNotificationInterno.vue?vue&type=script&lang=js&"
export * from "./ClicNotificationInterno.vue?vue&type=script&lang=js&"
import style0 from "./ClicNotificationInterno.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports